export default "__VITE_PUBLIC_ASSET__02960989__"